import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../../components/sidebar";
import {
  MainContainer,
  BackgroundPattern,
  SideContainer,
  ContentWrapper,
  HeaderSection,
  Title,
  Subtitle,
  ButtonRow,
  ButtonContainerLeft,
  ButtonContainerRight,
  StyledButton,
} from "../../ListAreas/styles";
import { firesService } from "../../../../services/firesService";
import { goToGuardianHub, GUARDIAN_PANEL } from "../../../../utils/appNavigation";
import { appStatus } from "../../../../store/modules/app_status/actions";
import {
  AreaCardList,
  AreaCard,
  AreaCardHeader,
  AreaCardName,
  AreaCardBbox,
  AreaCardStatus,
  AreaCardActions,
  RiskBadge,
  OkBadge,
  EmptyState,
} from "../styles";

const ListAllFirmsAreas = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const collapsed = useSelector((state) => state.sidebar);

  const [areas, setAreas] = useState([]);
  const [scans, setScans] = useState({});
  const [loading, setLoading] = useState(true);
  const [scanning, setScanning] = useState(null);

  const fetchAreas = async () => {
    try {
      const data = await firesService.listAreas();
      setAreas(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Erro ao buscar áreas FIRMS:", err);
      setAreas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(appStatus(GUARDIAN_PANEL));
  }, [dispatch]);

  useEffect(() => {
    fetchAreas();
  }, []);

  useEffect(() => {
    if (areas.length === 0) return;
    const loadScans = async () => {
      const scansMap = {};
      await Promise.all(
        areas.map(async (a) => {
          try {
            const list = await firesService.listAreaScans(a.id, 1);
            if (list?.[0]) scansMap[a.id] = list[0];
          } catch { /* ignore */ }
        })
      );
      setScans(scansMap);
    };
    loadScans();
  }, [areas]);

  const handleRunScan = async (areaId) => {
    setScanning(areaId);
    try {
      const result = await firesService.runAreaScan(areaId, 1);
      setScans((prev) => ({ ...prev, [areaId]: result }));
    } catch (err) {
      console.error("Erro ao executar scan:", err);
    } finally {
      setScanning(null);
    }
  };

  const renderContent = () => (
    <ContentWrapper>
      <ButtonRow>
        <ButtonContainerLeft>
          <StyledButton
              onClick={() => {
              goToGuardianHub(dispatch, navigate);
            }}
            >
            Voltar
          </StyledButton>
        </ButtonContainerLeft>
        <ButtonContainerRight>
          <StyledButton onClick={() => navigate("/firms/create")}>
            <span style={{ marginRight: "8px" }}>➕</span>
            Nova Área FIRMS
          </StyledButton>
        </ButtonContainerRight>
      </ButtonRow>

      <HeaderSection>
        <Title>🔥 Todas as Áreas FIRMS</Title>
        <Subtitle>Áreas de monitoramento de incêndios por satélite NASA</Subtitle>
      </HeaderSection>

      {loading ? (
        <EmptyState>Carregando áreas...</EmptyState>
      ) : areas.length === 0 ? (
        <EmptyState>Nenhuma área FIRMS cadastrada. Cadastre via detalhes de uma Área de Interesse.</EmptyState>
      ) : (
        <AreaCardList>
          {areas.map((area) => {
            const lastScan = scans[area.id];
            return (
              <AreaCard key={area.id}>
                <AreaCardHeader>
                  <AreaCardName
                    onClick={() => navigate(`/firms/areas/${area.id}`)}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    {area.name}
                  </AreaCardName>
                  {lastScan &&
                    (lastScan.has_risk ? (
                      <RiskBadge>🔴 Risco</RiskBadge>
                    ) : (
                      <OkBadge>🟢 OK</OkBadge>
                    ))}
                </AreaCardHeader>
                {area.bbox_str && <AreaCardBbox>Bbox: {area.bbox_str}</AreaCardBbox>}
                <AreaCardStatus>
                  {area.active ? "🟢 Ativa" : "⚫ Inativa"}
                </AreaCardStatus>
                <AreaCardStatus>
                  {lastScan
                    ? `${lastScan.detection_count} detecção(ões) — Último scan: ${new Date(lastScan.scan_at).toLocaleString("pt-BR")}`
                    : "Nenhum scan executado"}
                </AreaCardStatus>
                <AreaCardActions>
                  <StyledButton onClick={() => navigate(`/firms/areas/${area.id}`)}>
                    Ver detalhes
                  </StyledButton>
                  <StyledButton
                    secondary
                    onClick={() => handleRunScan(area.id)}
                    disabled={scanning === area.id}
                  >
                    {scanning === area.id ? "Executando..." : "Executar scan"}
                  </StyledButton>
                  <StyledButton
                    secondary
                    onClick={() => navigate(`/firms/areas/${area.id}/history`)}
                  >
                    Ver histórico
                  </StyledButton>
                </AreaCardActions>
              </AreaCard>
            );
          })}
        </AreaCardList>
      )}
    </ContentWrapper>
  );

  return (
    <MainContainer collapsed={collapsed}>
      <BackgroundPattern />
      <Sidebar />
      <SideContainer collapsed={collapsed}>
        {renderContent()}
      </SideContainer>
    </MainContainer>
  );
};

export default ListAllFirmsAreas;
